module.exports = {"TXTWCL_Bet_Slip":{"id":"TXTWCL_Bet_Slip","defaultMessage":"Kupon"}}